import { cx } from '@linaria/core';
import { AppStateType, useAppStateSelector } from '../../Hooks/useAppState';
import "./BannerRow.linaria.module.css!=!./BannerRow?./BannerRow.linaria.module.css?css=H4sIAAAAAAAAA2WT3Y6kIBBG7/cpvNlkJlk6QP+u+zAEFRAbKQdQ6Sbz7pPuGW11E2+Onqr6rMCOh5bRipGxwU0BuzWmgpdX5aC3FSrBgMsH7t4QWrwOjltv+lLY8P7v89ezwRmzfqxoOKYCIvI1r2DMnSr4G/6T/Tw7+p7hLmaki9m+i1PpXjIiLD3SkApwlXD5Q/BgdJVtZ8/zZMlIfYKmv28wNb0PWt5QCTYIG/JHTOHmnIYRG3Wsh7T8O+WEsKiV5TygXvWfKXGjlUU6iNZvWrv9LAURA3qaG6feM3I7HMDIDaaWO6UtCtDlh9du1MfKf+HkFxACtKuSO9NVJ9VhTVOBETLkeM6Dl/JMk+y0qhd2eWGVuV7isKYkwQbk9V3kZBGk9Mzqs8FqTd/2KJ6tT3hu/tczEuKoB5Mq7TvDb7k0Yu4mKCPgP4AOqf6uJRj/nr42J0ZEJJ7q1GqLfowjfaXhkV2Lsx3ua0qPGUg5GHMyqY/L0NBLE+kG/78bz6vQcSdsWBxnZW6jbKfTbMGKxQZFLMOlWNNyg6dn5i/tqbyypQMAAA=="
const stylesRoot = "atm_2d_1wj0jbo atm_70_uwd2t5 atm_3f_1en252t atm_fc_1h6ojuz atm_7l_1nxixhv atm_h_1h6ojuz atm_r3_1h6ojuz atm_h3_1y44olf atm_gq_1y44olf atm_gz_idpfg4 atm_h0_idpfg4 atm_c8_dlk8xv atm_cs_ni7l0g atm_9s_1txwivl atm_e2_1osqo2v atm_j6_1ex1s2i atm_ax_kb7nvz";
const stylesDarkMode = "atm_2d_1j28jx2 atm_3f_glywfm";

/** The personal time-of-day greeting reads a size up from the promotional offer */
const stylesGreeting = "atm_c8_exct8b";
const BannerRow = props => {
  const darkMode = useAppStateSelector(AppStateType.APP, 'darkMode');
  const {
    onClick,
    text,
    greeting
  } = props;
  return <div data-testid="Home__BannerRow" className={cx(stylesRoot, darkMode && stylesDarkMode, greeting && stylesGreeting)} onClick={onClick}>
            {text}
        </div>;
};
export default BannerRow;
export { BannerRow };